import { useQuery } from "hooks/useQuery";
import {
  getPublicStrategyDetails,
  getStrategyDetails,
} from "features/Strategy/service";
import { STRATEGY_ACCESS_DENIED_STATUSES } from "features/Strategy/constants";

// Every other failure keeps the client-wide `retry: 1` (Layout's QueryClient).
const DEFAULT_RETRY_COUNT = 1;

// A strategy the viewer may not see: a retry gets the same answer and only
// holds the page on its loading state for the retry delay. 401 is left to
// retry, because the axios interceptor refreshes the token and relies on it.
const retryDetails = (failureCount, error) =>
  !STRATEGY_ACCESS_DENIED_STATUSES.includes(error?.response?.status) &&
  failureCount < DEFAULT_RETRY_COUNT;

export const useStrategyDetails = (id, isPublicStrategy = false) => {
  const { isLoading, data, refetch, error, isError } = useQuery({
    key: "strategyDetails",
    queryKey: ["strategyDetails", id, isPublicStrategy],
    queryFn: async () => {
      if (isPublicStrategy) {
        const response = await getPublicStrategyDetails(id);
        return response;
      }
      const response = await getStrategyDetails(id);
      return response;
    },
    enabled: !!id,
    retry: retryDetails,
  });

  return {
    isLoading,
    data,
    refetch,
    error,
    isError,
    // HTTP status of the failure, when the request failed with a response.
    httpStatus: error?.response?.status,
  };
};
